






























import {Component, Vue} from "vue-property-decorator";
import axios from 'axios';
import {MutationList as modalMutations} from "@/store/modules/modal/mutation-list";

@Component
export default class History extends Vue {

    private userNamespace = 'user/';
    private modalNamespace = 'modal/';
    private showHistory = false;
    private history = [
        {
            name: 'some appointment name',
            institution: 'some institution name',
            institutionId: '0',
            doctorName: "some one some",
            doctorId: '1',
            date: '22.10.2026'
        },
        {
            name: 'some appointment name',
            institution: 'some institution name',
            institutionId: '0',
            doctorName: "some one some",
            doctorId: '1',
            date: '22.10.2026'
        },
        {
            name: 'some appointment name',
            institution: 'some institution name',
            institutionId: '0',
            doctorName: "some one some",
            doctorId: '1',
            date: '22.10.2026'
        },
        {
            name: 'some appointment name',
            institution: 'some institution name',
            institutionId: '0',
            doctorName: "some one some",
            doctorId: '1',
            date: '22.10.2026'
        },
    ];

    get userToken() {
        return this.$store.getters[`${this.userNamespace}getUserToken`];
    }

    async fetchData(){
        this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_LOADING_MODAL}`, 'search all information');
        await axios.get('https://dev.palmamedical.lv/user/' + this.userToken + '/history')
        .then(response => {
            this.history = response.data;
            if(this.history.length > 0) this.showHistory = true;
            this.$store.commit(`${this.modalNamespace}${modalMutations.SET_MODAL_VISIBILITY_FALSE}`);
        })
        .catch(e => {
            this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_MESSAGING_MODAL}`, {
                header: 'an error happened',
                message: e
            });
        })
    }

    // this enables ability to order same doctor appointment
    orderTheSame(id: number){
        this.$router.push({path: '/appointment', query: {doctor: id.toString(), service: ''}});
    }
}
